function rows(old, patches = [], order) {
    if (!patches.length && !order)
        return old;
    const byId = new Map(old.map((r) => [r.id, r]));
    const touched = new Set();
    for (const p of patches) {
        if (touched.has(p.id) || (p.set.id !== undefined && p.set.id !== p.id) || p.gone?.includes('id'))
            return null;
        touched.add(p.id);
        const was = byId.get(p.id);
        if (!was && (!order || !p.set.id))
            return null;
        const row = { ...was, ...p.set, id: p.id };
        for (const key of p.gone ?? [])
            delete row[key];
        byId.set(p.id, row);
    }
    const ids = order ?? old.map((r) => r.id);
    if (new Set(ids).size !== ids.length || ids.some((id) => !byId.has(id)))
        return null;
    return ids.map((id) => byId.get(id));
}
export function resolveSide(wire, matchId, held) {
    if (!Number.isSafeInteger(wire.version) || wire.version < 1)
        return null;
    if (wire.snapshot) {
        const scope = `${wire.snapshot.faction}:${wire.snapshot.fileOnly ? 'FILE' : 'POOLED'}`;
        return wire.scope === scope && wire.version > 0
            ? { matchId, scope, version: wire.version, value: wire.snapshot } : null;
    }
    if (!held || held.matchId !== matchId || held.scope !== wire.scope || held.version !== wire.base
        || (wire.version !== wire.base && wire.version !== wire.base + 1))
        return null;
    if (wire.version === wire.base) {
        return wire.cities || wire.intel || wire.cityOrder || wire.intelOrder || wire.exchanges || wire.lastRound || wire.clearLastRound || wire.incoming || wire.clearIncoming ? null : held;
    }
    const cities = rows(held.value.cities, wire.cities, wire.cityOrder);
    const intel = rows(held.value.intel, wire.intel, wire.intelOrder);
    if (!cities || !intel)
        return null;
    const value = { ...held.value, cities, intel,
        ...(wire.exchanges ? { exchanges: wire.exchanges } : {}),
        ...(wire.lastRound ? { lastRound: wire.lastRound } : {}),
        ...(wire.incoming ? { incoming: wire.incoming } : {}),
    };
    if (wire.clearIncoming)
        delete value.incoming;
    if (wire.clearLastRound)
        delete value.lastRound;
    return { matchId, scope: held.scope, version: wire.version, value };
}
/** The chart, supply panel and HQ read the same allied stock/status rows. */
export function alliesFromSide(side, view) {
    return side.cities.filter((c) => c.owner !== view.you.id).map((c) => ({
        id: c.id, owner: c.owner, name: c.name, faction: side.faction,
        mx: c.mx, my: c.my, cluster: c.cluster, region: c.region, defeated: c.defeated,
        health: c.health, nuclear: c.nuclear ?? 'none', doctrine: c.doctrine, signals: c.signals ?? [],
        contaminated: c.contaminated, frozen: c.frozen, arsenal: c.arsenal,
        interceptors: { held: c.interceptors.held, sited: c.interceptors.sited, cap: c.interceptors.cap },
        mast: c.mast, inReach: !view.city.defeated && !c.defeated,
    }));
}
//# sourceMappingURL=sideWire.js.map